module.exports = __webpack_public_path__ + "static/media/EE_2.c3de6eb9.PNG";